import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import firebase from "firebase/compat/app"

import { firebaseConfig } from './firebase'
import { doCreateUserWithEmailAndPassword } from './auth'
import { useAuth } from './authContext'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'

firebase.initializeApp(firebaseConfig)

const Register = () => {
  const { userLoggedIn } = useAuth()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isRegistering, setIsRegistering] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [name, setName] = useState('')
  const options = ['Real Estate Agent', 'Aspiring Investor', 'Student']
  const [myValue, setMyValue] = useState(options[0])

  const [accessCode, setAccessCode] = useState('')
  const [accessToken, setAccessToken] = useState(0)
  const [totalSearches, setTotalSearches] = useState(0)
  const [marketResearchSearches, setMarketResearchSearches] = useState(0)
  const [previousStudent, setPreviousStudent] = useState(false)

  // Apply access code logic on change
  useEffect(() => {
    const lower = accessCode.trim().toLowerCase()
    if (lower === 'cashflowing') {
      setAccessToken(4)
      setTotalSearches(20)
      setMarketResearchSearches(0)
      setPreviousStudent(false)
    } else if (lower === 'rei') {
      setAccessToken(5)
      setTotalSearches(100)
      setMarketResearchSearches(100)
      setPreviousStudent(false)
    } else if (lower === 'buildingwealth') {
      setAccessToken(5)
      setTotalSearches(100)
      setMarketResearchSearches(100)
      setPreviousStudent(true)
    } else {
      setAccessToken(0)
      setTotalSearches(0)
      setMarketResearchSearches(0)
      setPreviousStudent(false)
    }
  }, [accessCode])

  const handleChange = (event) => {
    setMyValue(event.target.value)
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    if (password !== confirmPassword) {
      setErrorMessage('Passwords do not match')
      return
    }
    setIsRegistering(true)
    try {
      await doCreateUserWithEmailAndPassword(
        email,
        password,
        myValue,
        name,
        accessToken,
        totalSearches,
        marketResearchSearches,
        previousStudent
      )
    } catch (err) {
      setErrorMessage(err.message)
    } finally {
      setIsRegistering(false)
    }
  }

  return (
    <div>
      {userLoggedIn && <Navigate to={'/dealexplorer'} replace={true} />}
      <main className="w-full h-screen flex self-center place-content-center place-items-center">
        <div className="w-96 text-gray-600 space-y-5 p-4 shadow-xl border rounded-xl bg-white">

          <div className="text-center mb-6">
            <div className="flex justify-center items-center">
              <img
                src="https://i.ibb.co/s2dBvDt/elevate.png"
                alt="logo"
                className='bg-white'
                width={500}
              />
            </div>
          </div>

          <form onSubmit={onSubmit} className="space-y-4">
            {/* Name */}
            <div>
              <label className="text-sm text-gray-600 font-bold">Name</label>
              <input
                type="text"
                autoComplete='name'
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
              />
            </div>

            {/* Email */}
            <div>
              <label className="text-sm text-gray-600 font-bold">Email</label>
              <input
                type="email"
                autoComplete='email'
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
              />
            </div>

            {/* Password */}
            <div>
              <label className="text-sm text-gray-600 font-bold">Password</label>
              <input
                disabled={isRegistering}
                type="password"
                autoComplete='new-password'
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
              />
            </div>

            {/* Confirm Password */}
            <div>
              <label className="text-sm text-gray-600 font-bold">Confirm Password</label>
              <input
                disabled={isRegistering}
                type="password"
                autoComplete='off'
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
              />
            </div>

            {/* Role Picker */}
            <div>
              <label className="text-sm text-gray-600 font-bold">I am a..</label>
              <FormControl fullWidth>
                <Select value={myValue} onChange={handleChange}>
                  <MenuItem value={"Real Estate Agent"}>Real Estate Agent</MenuItem>
                  <MenuItem value={"Aspiring Investor"}>Aspiring Investor</MenuItem>
                  <MenuItem value={"Student"}>Student</MenuItem>
                </Select>
              </FormControl>
            </div>

            {/* Access Code */}
            <div>
              <label className="text-sm text-gray-600 font-bold">Access Code</label>
              <input
                type="text"
                autoComplete='off'
                required
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value)}
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
              />
            </div>

            {errorMessage && <span className='text-red-600 font-bold'>{errorMessage}</span>}

            {/* Sign Up Button */}
            <button
              type="submit"
              disabled={isRegistering || accessToken === 0}
              className={`w-full px-4 py-2 text-white font-medium rounded-lg ${
                isRegistering || accessToken === 0
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-[#34b22c] hover:border-5 hover:border-green-600 hover:bg-white hover:text-[#34b22c] hover:shadow-xl transition duration-300'
              }`}
            >
              {isRegistering ? 'Signing Up...' : 'Sign Up'}
            </button>
          </form>
        </div>
      </main>
    </div>
  )
}

export default Register
